import React from 'react';
//import { Route, Link, BrowserRouter as Router } from 'react-router-dom'
//import ReactDOM from 'react-dom';
import ReactDOM from 'react-dom/client';

 
import setAuthorizationToken from './utils/setAuthorizationToken';
// import jwtDecode from 'jwt-decode';
// import { setCurrentUser } from './actions/authActions';



//https://www.codingame.com/playgrounds/9396/redux-form-validation-tutorial
  
//import { reducer as formReducer } from 'redux-form';


 import App from './App';
import './index.css';

import * as serviceWorker from './serviceWorker';



//https://reactgo.com/react-global-variable/
 
 //window.$__imgCDNURL = 'https://www.activeresearch.com'; //global variable
 // must be this when CDN ready window.$__imgCDNURL = 'https://lhcfmsftprotos.azureedge.net'; //global variable
 //window.$__imgCDNURL = 'https://lhcfimgpremblob.z20.web.core.windows.net'; //global variable
 window.$__imgCDNURL = 'https://letscupidmsftcdnprotos.azureedge.net/'; 
 window.$__imgCDNURL = 'https://letscupidmsftcdnprotos.activeresearch.com/'; 

 window.$__ver = "1.0.0"


 //change this conditionaly if localhost that
 // if(window.location.hostname ==='127.0.0.1') // was changed in .ENV
 if(window.location.hostname ==='localhost')
 {
   window.$__APIPortal = 'https://localhost:7100'; //local/public variable 
   window.$__WebSiteDomain = 'localhost:7100'; //local/public variable  
   window.$__PortalWebSiteDomain = 'localhost:7100'; //local/public variable  
 }
 else{
  window.$__APIPortal = 'https://apiportal.activeresearch.com'; //local/public variable
  window.$__WebSiteDomain = '.activeresearch.com'; //local/public variable 
  window.$__PortalWebSiteDomain = 'portal.activeresearch.com'; //local/public variable  
 }

 //photos change to CDN because the guid of the photos 
 window.$__PHOTOSCDN ='https://msftcdnprotos.activeresearch.com/';


 // window.$__table_lhcfverpremtable = 'https://letshavecoffeefirstback.table.core.windows.net/'; 
 window.$__table_lhcfverpremtable = 'https://letscupideus2tableprod1.azureedge.net/'; 
 
  
 //CDN for JSONs
//window.$__APIURLJSONCDN ='https://lhcfimgpremblob.z20.web.core.windows.net/';
 // window.$__APIURLJSONCDN ='https://azcollectus2pr001.blob.core.windows.net/'; 
  window.$__APIURLJSONCDN ='https://arcollectus2pr001.z20.web.core.windows.net/'; 

  
 
 

 

//import routes from './Routes/Routes';
 


 
 /* 
ReactDOM.render(
  routes ,
    document.getElementById('root')
    );
   */
  

 
 

if (localStorage.jwtToken) {
  setAuthorizationToken(localStorage.jwtToken);
 // store.dispatch(setCurrentUser(jwtDecode(localStorage.jwtToken)));
}

   

// ReactDOM.render(
//   <App /> 
//  , document.getElementById('root'));
const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);
root.render(<App />);
 

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

 